module.exports = __webpack_public_path__ + "img/fail_img.6fc5622e.png";